// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__C6mL2","text":"SelectPayment_text__aaGzF","title":"SelectPayment_title__i8yOr","btn":"SelectPayment_btn__3EBAK"};